export default {
  PARENT: 'PARENT',
  STUDENT: 'STUDENT',
};
